import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import {
  marketingContainerSx,
  marketingPageRootSx,
} from "../utils/marketingPageLayout";
import me from "../images/michael-abell-about.png";

const cardSx = {
  bgcolor: "#fff",
  borderRadius: 2,
  borderColor: "rgba(0,0,0,0.08)",
  boxShadow:
    "0 1px 2px rgba(0,0,0,0.04), 0 4px 14px rgba(0,0,0,0.06)",
};

const About = () => {
  return (
    <Box sx={{ ...marketingPageRootSx, bgcolor: "#fff", color: "#111" }}>
      <Container
        maxWidth="xl"
        sx={{ ...marketingContainerSx, py: { xs: 4, md: 7 } }}
      >
        <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 4 }, ...cardSx }}>
          <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
            <Grid item xs={12} md={5}>
              <Box
                component="img"
                src={me}
                alt="Mike Abell"
                sx={{
                  display: "block",
                  width: "100%",
                  maxWidth: 480,
                  mx: "auto",
                  borderRadius: 2,
                }}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: "2rem", md: "2.6rem" },
                  fontWeight: 900,
                  lineHeight: 1,
                  mb: 2,
                }}
              >
                About Us
              </Typography>
              <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6, mb: 2 }}>
                Hi! I'm Mike. I've been an athlete all my life, starting with
                swimming when I was a kid, then rock climbing, and now
                powerlifting.
              </Typography>
              <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6, mb: 2 }}>
                I've always trained people in my respective sports, and I really
                enjoy sharing my passions with others while teaching the
                techniques that help them move better and get stronger.
              </Typography>
              <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
                As a NASM Certified Personal Trainer, PLU Certified Referee, and
                Pain Performance Certified Trainer, I'm excited to help more
                athletes and everyday lifters build confidence, consistency, and
                strength through coaching.
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <Paper
          variant="outlined"
          sx={{
            p: { xs: 2.5, md: 4 },
            mt: { xs: 3, md: 4 },
            ...cardSx,
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.7rem", md: "2.1rem" },
              fontWeight: 900,
              lineHeight: 1.1,
              mb: 2,
            }}
          >
            Why I Built Trainer App
          </Typography>
          <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6, mb: 2 }}>
            I built Trainer App because I was tired of clunky apps that made it
            confusing and difficult to log workouts while I was sweaty at the
            gym. I wanted an app that made logging simple and could
            automatically track my progress over time.
          </Typography>
          <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6, mb: 2 }}>
            As a coach, I wanted a simple way to review clients' workouts and
            programs, especially for remote clients. I also wanted the app to
            keep communication clear and consistent with clients who might be on
            the other side of the world.
          </Typography>
          <Typography sx={{ fontSize: "1.05rem", lineHeight: 1.6 }}>
            For in-person coaching, I wanted that same clarity and workflow, with
            payments handled automatically so I do not have to track people down
            or have awkward conversations about billing.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default About;
